import { Radio } from 'antd'
import styled from 'styled-components'

const WrapButtons = styled(Radio.Button)`
  display: flex;
  justify-content: center;
  width: 100%;
`

const WrapContainer = styled(Radio.Group)`
  display: flex;
  justify-content: center;
  width: 100%;
`

export { WrapContainer, WrapButtons }
